// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__2VzCe","horizontal":"List_horizontal__3YR_e"};